import { useParams } from 'react-router-dom';
import UserProfile from './UserProfile';

export default function PublicProfilePage({ auth }) {
  const { userId } = useParams();

  return <UserProfile userId={userId} auth={auth} />;
}
